import { InputStyled, LabelStyled } from '@OnArk/styles/Form.styled';

import React, {
  FormEvent,
  KeyboardEvent,
  ReactElement,
  useEffect,
} from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useForm } from '@hangar31/rc-form';
import usePrevious from '@OnArk/hooks/usePrevious';
import slugify from 'slugify';

const LinkInputStyled = styled.div(
  ({ theme }) => ({
    p: theme.font('sm'),
  }),
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;

    border-radius: 0.5rem;
    h1 {
      margin: 0;
    }
    div {
      display: flex;
      flex: 1;
      width: 100%;
      padding: 1rem 1.2rem;

      background: ${theme.colors.white};
      border: 1px solid ${theme.colors.border};
      border-radius: 0.4rem;
    }
    p {
      margin: 0;

      color: ${theme.colors.grayMed};
      font-size: 1.2rem !important;
      line-height: 1em;
    }
    input {
      flex: 1;
      margin: -0.1rem 0 0 0;
      padding: 0;

      color: ${theme.colors.grayDark};
      font-size: 1.2rem !important;
      line-height: 1em;
    }
    label {
      margin: 0;
    }

    button {
      margin-top: 1rem;
    }
  `
);

function CourseLink({ churchUrl }: { churchUrl?: string }): ReactElement {
  // Only the two fields this component touches; the surrounding course form
  // has more.
  const { fields, setField } = useForm<{ name?: string; url?: string }>();
  const previousName = usePrevious(fields.name ?? '');

  useEffect(() => {
    // if there is no link or the link matches the previous title (AKA hasn't been customized)
    if (
      !fields.url ||
      fields.url === slugify(previousName || '', { lower: true, strict: true })
    ) {
      setField(
        'url',
        slugify(fields.name || '', { lower: true, strict: true })
      );
    }
  }, [fields.name]);

  return (
    <LinkInputStyled>
      <LabelStyled>
        <span>Share Link</span>
      </LabelStyled>
      <div>
        <p>{`/${churchUrl}/`}</p>
        <span css={{ display: 'none' }}>Class URL</span>
        <InputStyled
          css={{ border: 'none' }}
          name="url"
          pattern="[a-z0-9\-]+"
          onInvalid={(event: FormEvent<HTMLInputElement>) => {
            (event.target as HTMLInputElement).setCustomValidity(
              'should only contain lowercase letters, numbers and dashes'
            );
          }}
          onKeyDown={(event: KeyboardEvent<HTMLInputElement>) =>
            (event.target as HTMLInputElement).setCustomValidity('')
          }
        />
      </div>
    </LinkInputStyled>
  );
}

export default CourseLink;
